// Determine whether the widget is current locked

const forceRegistrationOverride = false; // this is used for testing disabled state of tools.

export default function getRegistrationLockedStatus(data, envData = {}, registrationConfig = {}) {
  if (!data) return false;

  const isLocked = forceRegistrationOverride || (
    data.locked &&
    registrationConfig.enabled &&
    (envData.userAccessLevel === 'anonymous' || envData.userId === 'none')
  );

  // console.log('getRegistrationLockedStatus', data.type, data, forceRegistrationOverride, data.locked, registrationConfig, registrationConfig.enabled, envData, envData.userAccessLevel, envData.userId, isLocked )

  if (envData.isApp && envData.env === 'prod') {
    console.log('getRegistrationLockedStatus isAPP and isProd - always return false until ios/android release', envData);
    return false;
  }

  if (envData.isAmp && envData.env === 'prod') {
    console.log('getRegistrationLockedStatus isAMP and isProd - always return false until amp reg work is completed', envData);
    return false;
  }

  return isLocked;
}
